import { createContext, useMemo, useState } from 'react';
import { useAuth } from '../../context/AuthContext';

/**
 * État PARTAGÉ du module doc — ce que plusieurs écrans du module doivent voir
 * ensemble et qui ne vient pas du magasin reactive-json d'une page :
 *
 *   • `spaceCategories` — les catégories d'espace, alimentées par la page (pont
 *     `DocHubBridge`) et par l'écran de configuration, lues par le formulaire de
 *     création d'espace et par les réglages d'un répertoire ;
 *   • `showSpaceForm`   — la demande « ouvrir le formulaire de création », que la
 *     barre latérale (React) adresse à la page (YAML) ;
 *   • `settingsSection` — l'onglet actif de /docs/settings ;
 *   • `isAdmin`         — recopié du contexte d'authentification pour éviter à
 *     chaque composant de le rechercher.
 *
 * Ce contexte ne porte PLUS ni filtres ni favoris : la liste des espaces (/docs)
 * filtre en YAML (`DataFilter` + `FacetList`) et pose ses signets avec le
 * mécanisme commun à tout Orbit (`FavoriteToggle` + /api/user/prefs), le même
 * que /projets. Voir `front_app/public/pages/doc/hub.yaml`.
 */
export const DocFiltersContext = createContext(null);

export function DocFiltersProvider({ children }) {
    const { isAdmin } = useAuth();

    const [spaceCategories, setSpaceCategories] = useState([]);
    const [showSpaceForm, setShowSpaceForm] = useState(false);
    const [settingsSection, setSettingsSection] = useState('categories');

    const value = useMemo(
        () => ({
            isAdmin,
            spaceCategories,
            setSpaceCategories,
            showSpaceForm,
            setShowSpaceForm,
            settingsSection,
            setSettingsSection,
        }),
        [isAdmin, spaceCategories, showSpaceForm, settingsSection],
    );

    return (
        <DocFiltersContext.Provider value={value}>
            {children}
        </DocFiltersContext.Provider>
    );
}
